


















import Vue, { PropType } from 'vue';
import { Row } from '@/components/table/types';

export default Vue.extend({
  name: 'ExpandPanel',
  props: {
    row: {
      type: Object as PropType<Row>,
    },
    getLocalStoragePeriod: {
      type: Function,
    },
  },
  mounted() {
    const expandPeriod = this.getLocalStoragePeriod();

    if (expandPeriod) {
      this.activePeriod = expandPeriod;
    }
  },
  methods: {
    changePeriod(value: string, row) {
      this.activePeriod = value;
      this.$emit('changeExpandPeriod', this.activePeriod, row);
    },
  },
  data: function() {
    return {
      activePeriod: '',
      expandPeriodList: [
        {
          label: this.$t('body.table.detailStatistics.10minute'),
          value: '10',
        },
        {
          label: this.$t('body.table.detailStatistics.30minute'),
          value: '30',
        },
        {
          label: this.$t('body.table.detailStatistics.1hour'),
          value: '60',
        },
        {
          label: this.$t('body.table.detailStatistics.1day'),
          value: '1440',
        },
        {
          label: this.$t('body.table.detailStatistics.7day'),
          value: '10080',
        },
        {
          label: this.$t('body.table.detailStatistics.1month'),
          value: '43200',
        },
      ],
    };
  },
});
